export default __webpack_public_path__ + "static/media/rocket_anim_50.87510491.png";